import { Col, motion, useSwipeAway, useTheme } from "@rally/ui-kit";
import { useEffect, useRef, useState } from "react";
import { Panel } from "./panels.tsx";
import type { Card } from "./stacking.ts";

export function Drawer({
  card,
  leaving,
  under,
  focused = false,
  onDismiss,
}: {
  card: Card;
  leaving: boolean;
  under: boolean;
  focused?: boolean;
  onDismiss?: () => void;
}) {
  const theme = useTheme();
  const [arrived, setArrived] = useState(theme.preferReduced);
  const had = useRef<HTMLElement | null>(null);
  useEffect(() => {
    had.current = document.activeElement as HTMLElement | null;
    return () => {
      if (had.current && document.activeElement === document.body) had.current.focus?.();
    };
  }, []);
  useEffect(() => {
    if (theme.preferReduced) return;
    const frame = requestAnimationFrame(() => setArrived(true));
    return () => cancelAnimationFrame(frame);
  }, [theme.preferReduced]);
  const { drag, handlers } = useSwipeAway(() => onDismiss?.());
  return (
    <Col
      testID={under ? "resource-extension" : "details-extension"}
      accessibilityViewIsModal
      aria-modal
      {...handlers}
      style={
        {
          position: "absolute",
          inset: 0,
          zIndex: under ? 2 : 1,
          transform: `translateX(${drag > 0 ? `${drag}px` : arrived && !leaving ? "0" : "100%"})`,
          ...(theme.preferReduced || drag > 0
            ? {}
            : {
                transitionProperty: "transform",
                transitionDuration: `${motion.drawer.duration}ms`,
                transitionTimingFunction: motion.drawer.easing,
              }),
        } as object
      }
    >
      <Panel card={card} under={under} wide={false} focused={focused} />
    </Col>
  );
}
